// src
import config from "config";
import { networkError } from "actions/system";
import { disconnect } from "actions/user";

const getResourceAndOptions = (req) => {
  if (typeof req === "string") return [req, null];
  const { resource, ...options } = req;
  return [resource, options];
};

const request = async (
  req,
  dispatch,
  getState,
  requestCallback,
  successCallback,
  failureCallback,
) => {
  let res;
  let payload;

  try {
    const [resource, options] = getResourceAndOptions(req);
    const { token } = getState().user;
    const headers = { "Content-type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    if (requestCallback) requestCallback();
    res = await fetch(`${config.backRoot}${resource}`, { headers, ...options });

    if (res.status === 401 && token) {
      dispatch(disconnect());
      return;
    }

    if (!res.ok) {
      if (failureCallback) failureCallback(res.status);
      dispatch(networkError());
      return;
    }

    const contentType = res.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      payload = await res.json();
    }
  } catch (err) {
    if (failureCallback) {
      if (res) failureCallback(res.status);
      else failureCallback();
    }
    dispatch(networkError());
    console.error(err);
    return;
  }

  successCallback(payload);
};

export default { request };
